import { FunctionComponent, PropsWithChildren } from 'react';

export interface loginContentLayoutProps {
  hasMembership: boolean | null;
  isLoggedIn: boolean;
  membershipError: string;
}

export const LoginContentLayout: FunctionComponent<
  PropsWithChildren<loginContentLayoutProps>
> = ({ hasMembership, isLoggedIn, membershipError }) => {
  return (
    <>
      {isLoggedIn && hasMembership === false ? (
        <>
          {membershipError == 'no_membership' ? (
            <>
              <h2>
                Your D23 account is not associated with a membership level
              </h2>
              <p>
                Select a membership level in your&nbsp;
                <a href="https://d23.com" rel={'noreferrer'} target={'_blank'}>
                  D23 account
                </a>
                &nbsp;to continue
              </p>
            </>
          ) : (
            <>
              <h2>There was an error</h2>
              {/*The response from D23 can have html*/}
              <p dangerouslySetInnerHTML={{ __html: membershipError }}></p>
            </>
          )}
        </>
      ) : (
        <>
          <h2>Sign in to your Member ID for access</h2>
          <p>Tickets available to D23 Members only</p>
          <a href="https://d23.com/join/">
            Not a D23 Member? Join today! to reserve tickets.
          </a>
        </>
      )}
    </>
  );
};
